<div @show class="body" *ngIf="!nextcloudError; else nextcloudErrorHint">

    <div class="content" (click)="uploadFiles.click()" appDragAndDrop (filesDropped)=filesSelected($event)>

        <div class="background-hint" *ngIf="files.length === 0; else filesWrapper">
            Sie können Dateien per Drag and Drop einfügen oder durch Klick auswählen
        </div>

    </div>

    <div class="file-list">

        <div class="headline">
            Bereits hochgeladene Dateien
        </div>

        <div class="file-content">

            <div *ngIf="nextcloudFolder.length === 0; else nextcloudContent" class="no-nextcloud-files-hint">
                Keine Dateien vorhanden
            </div>

        </div>

    </div>

</div>

<input #uploadFiles type="file" accept="*" style="display: none;" (input)="filesSelected($event.target.files)" multiple="multiple" />

<ng-template #filesWrapper>

    <div class="files-wrapper">

        <ng-container *ngFor="let file of files">

            <div class="file-wrapper" (click)="$event.stopPropagation()">
    
                <app-local-file-preview [file]="file"></app-local-file-preview>

                <button mat-icon-button color="warn" (click)="removeUploadFile($event, file)">
                    <mat-icon>clear</mat-icon>
                </button>
    
            </div>
    
        </ng-container>

    </div>

</ng-template>

<ng-template #nextcloudContent>

    <div class="nextcloud-files-wrapper">

        <ng-container *ngFor="let file of nextcloudFolder">

            <app-nextcloud-file-preview [file]="file" (click)="previewFile($event, file)"></app-nextcloud-file-preview>

        </ng-container>

    </div>

</ng-template>

<ng-template #nextcloudErrorHint>

    <div class="error-hint">

        <div>Fehler beim Abrufen des Nextcloud Ordners</div>

    </div>

</ng-template>
